import { api as defaultApi } from './api';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import * as navigate from 'app/area/shared/navigation';
import { CreateEditDraft } from 'app/area/case/edit/action-types';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { actionCreators as responseCachingActionCreators } from 'app/area/shared/response-caching/actions';

export const actionCreators = (api: any = defaultApi) => ({

   editCase: (caseId: number, caseContextId: number = undefined, entityPath: string = undefined): 
   ActionDispatching<any, ApplicationState> => 
    async (dispatch: any, getState: any) => {
      try{
        dispatch(new CreateEditDraft(caseId));        

        const { location: draftId, response } = await api.editCase(caseId, caseContextId);
        
        // Precache ui-definition
        if (response && response.data && response.data.caseContext && response.data.caseType) {
          const returnedCaseTypeId = response.data.caseType.v;
          const returnedCaseContextId = response.data.caseContext.v;
          dispatch(responseCachingActionCreators.getUiDefinition(returnedCaseTypeId, returnedCaseContextId));
        }

        navigate.toDraft( draftId, undefined, entityPath );
      } catch (err) {
        dispatch(new ErrorNotification(err.userMessages || err.message));
        navigate.toCaseView(caseId);
      }
  }
});
